import { useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import CreateButton from "../../../components/ToolBar/Buttons/CreateButton";
import RecordPerPage from "../../../components/ToolBar/Dropdown/RecordPerPage";
import ContentBox from "../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
// import { details,setPerPage, setDetails, deleteRecord, fetchList } from "./utils/slice";
import { details,setPerPage, setDetails,deleteRecord, fetchList } from "./utils/slice";
import DeleteModal from "../../../components/Modals/DeleteModal";
import AddComponent from "./components/Form/AddComponent";
import EditComponent from "./components/Form/EditComponent";
// import ViewDrawer from "./components/ViewDrawer";

import { IndustryBreadcrumb } from "../../../config/BreadcrumbConfig";
import { toUpperCaseWithUnderscore } from "../../../utils/commonFunctions";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/hooks";
import { CONSTANT } from "../../../config/Constant";
import { setEditLoading, setViewLoading } from "../../../store/CommonSlice";
import React from "react";

const moduleInfo = {
  title: "Industry",
  permissionKeyPrefix: toUpperCaseWithUnderscore("Industries"),
};

/**
 * Renders the Access Codes component which displays a list of races, allows creation and editing of races,
 * and deletion of races. It also allows the user to set the number of races to display per page.
 *
 * @return {JSX.Element} The rendered Access Codes component.
 */
const Industry: React.FC<any> = () => {
  const dispatch = useAppDispatch();
//   const { perPage } = useAppSelector(state => state.race);
  const [isCreateVisible, setIsCreateVisible] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [deleteValue, setDeleteValue] = useState<any>();
  // const [viewDrawer, setViewDrawer] = useState(false);

  useEffect(() => {
    dispatch(fetchList()).catch((error: any) => error);
  }, []);


   /**
   *  set loading on action button click and dispatch details 
   * api call and set loading to false on success and open drawer.
   * and throw error on failure.
    */ 
   const getDetails = (data: any, type: string) => {
    if (type === CONSTANT.DRAWER_TYPE.EDIT) {
      dispatch(setEditLoading([true, data.id]));
    }
    
    dispatch(details(data.id))
      .then((data:any) => {
        if (type === CONSTANT.DRAWER_TYPE.EDIT) {
          setEditDrawer(true);
          dispatch(setEditLoading([false, data.id]));
        }
      })
      .catch((error: any) => error);
  };
  

  return (
    <>
     <ToolBar breadcrumbs={IndustryBreadcrumb}>
     <CreateButton
          action={() => setIsCreateVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
        />
     </ToolBar>
     <ContentBox>
     <Listing
          moduleInfo={moduleInfo}
          handleEditClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.EDIT);
          }}
          handleDeleteClick={setDeleteValue}
          handleViewClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.VIEW);
          }}
        />
     <AddComponent
          titleName={moduleInfo.title}
          open={isCreateVisible}
          close={() =>setIsCreateVisible(false)}
          />
   
     <EditComponent
          titleName={moduleInfo.title}
          open={editDrawer}
          close={() => dispatch(setDetails(null)) && setEditDrawer(false)}
        />
       <DeleteModal
          title={moduleInfo.title}
          deleteValues={deleteValue}
          callApi={deleteRecord}
          close={() => setDeleteValue(null)}
        />
     </ContentBox>
    </>
  );
};

export default Industry;
